<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="'工单列表详情，' + tableData.length"
      width="85%"
      top="2vh">
    <!--    <el-button :loading="exportLoading" style="margin-bottom: 5px" type="primary" @click="exportExcel">导出</el-button>-->
    <el-table v-loading="contentLoading" height="76vh" :data="tableData">
      <!--      <el-table-column type="selection" align="center" width="30"/>-->
      <el-table-column prop="statusName" align="center" label="状态" width="60" fixed="left"/>
      <el-table-column prop="productionOrderNo" align="center" label="工单编号" width="150" fixed="left"/>
      <el-table-column prop="billNo" align="left" label="派工单号" width="113" fixed="left"/>
      <!--      <el-table-column prop="billNo" align="left" label="派工单号" width="113" fixed="left">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span style="color: #2d8cf0;cursor: pointer;" @click="$refs.SAPProductionOrderDetail.open(scope.row,0)">-->
      <!--            {{scope.row.billNo}}-->
      <!--          </span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="feedingStatusName" align="center" label="发料状态" width="90"/>
      <el-table-column prop="materialNo" width="140" align="center" label="物料编号"/>
      <el-table-column prop="materialName" width="200" label="物料名称"/>
      <el-table-column prop="specification" width="200" label="规格型号"/>
<!--      <el-table-column prop="price" :v-if="queryType===7" width="100" label="出厂价"/>-->
      <el-table-column prop="workCenterName" align="center" label="工作中心" width="120"/>
      <el-table-column prop="erpSalesOrderNo" align="center" label="销售订单" width="140"/>
      <el-table-column prop="customerName" align="center" label="客户" width="220"/>
      <el-table-column prop="finalCustomerName" align="center" label="最终客户" width="220"/>
      <el-table-column prop="deliveryDate" align="center" label="订单要求交期" width="100"/>
      <el-table-column prop="currProcessName" align="center" label="当前工序" width="150"/>
      <el-table-column prop="quantity" align="center" label="数量" width="50"/>
      <el-table-column prop="warehousingQuantity" align="center" label="入库数量" width="80"/>
      <el-table-column prop="planStartTime" align="center" label="计划开始日期" width="95"/>
      <el-table-column prop="planFinishTime" align="center" label="计划完成日期" width="95"/>
      <el-table-column prop="startTime" align="center" label="实际开工时间" width="140"/>
      <el-table-column prop="finishTime" align="center" label="实际完工时间" width="140"/>
      <el-table-column prop="inspectionTime" align="center" label="检验时间" width="140"/>
      <el-table-column prop="instockTime" align="center" label="入库时间" width="140"/>
      <el-table-column prop="salesOrderMaterialNote" align="center" width="300" label="备注"/>
    </el-table>
    <!--    <s-a-p-production-order-details ref="SAPProductionOrderDetail"/>-->
  </el-dialog>
</template>

<script>
  import constant from "@/util/constant";

  export default {
    name: "WorkOrderDetailList",
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        exportLoading: false,
        tableData: [],
        tableDataBill: [],
        salesOrderType: null,
        countType: null,
        queryType: null,
        productType: null,
        searchType: null,
        startTime: null,
        endTime: null,
        cycleEndDate: null,
        deliveryTimeType: null,
      };
    },
    methods: {
      open(startTime, endTime, countType, productType, queryType, searchType) {
        this.startTime = startTime;
        this.endTime = endTime;
        this.queryType = queryType;
        this.searchType = searchType;
        this.countType = countType;
        this.productType = productType;
        this.tableData = [];
        this.tableDataBill = [];
        this.dialogVisible = true;
        this.getList();
      },
      getList() {
        let params = {
          "startTime": this.startTime,
          "endTime": this.endTime,
          "queryType": this.queryType,
          "countType": this.countType,
          "productType": this.productType,
          "searchType": this.searchType,
        };
        this.contentLoading = true;
        this.$http.get("basic", "productReports/workOrderDetailOnDate", params)
            .then((res) => {
              this.contentLoading = false;
              this.tableData = res.data;
            }).catch(() => {
          this.contentLoading = false;
          // this.$message.error("获取失败");
        });
      },
      exportExcel() {
        this.exportLoading = true;
        let params = {
          "startTime": this.startTime,
          "endTime": this.endTime,
          "queryType": this.queryType,
          "countType": this.countType,
          "productType": this.productType,
          "searchType": this.searchType,
        };
        this.$http
            .exportFile("basic", "productReports/exportWorkOrderDetailOnDate", params, 60 * 10000)
            .then(res => {
              let blob = new Blob([res.data]);
              let fileName = decodeURI(res.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.exportLoading = false;
            }).catch(() => {
          this.exportLoading = false;
          this.$message.error("导出失败");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
